import { PrivacyFormValues } from "../components";
import { ContentPrivacyAndTerms } from "../content.types";

export const getInitialPrivacyFormValues = (
  editablePrivacy: ContentPrivacyAndTerms | undefined
): PrivacyFormValues => ({
  privacy: editablePrivacy?.privacyPolicy ?? "",
  terms: editablePrivacy?.termsOfService ?? ""
});
